import React, { useState } from 'react';
import c from 'classnames';
import { useStore } from 'react-redux';
import { documentSetCookie } from '../../cookie';
import styles from './css/Dropdown.css';
import { ClickElement } from '../form';

export const Dropdown = ({ 
  defaultSort, 
  availableSorting, 
  changeSorting,
  setCookieValue,
  ...restProps
}) => {
  const { dispatch } = useStore();
  const [currentDropDownState, setDropDownState] = useState(false);
  const currentActiveItem = availableSorting.find(item => item.sorting === defaultSort);
  const activeItemLabel = currentActiveItem ? currentActiveItem.label : 'Kies sortering';
  return(
    <div className={styles.dropdown} {...restProps}>
      <ClickElement
        tertiary
        ElementType="div"
        type="button"
        text={activeItemLabel}
        onClick={() => setDropDownState(!currentDropDownState)}
      />
      <div className={c(
        styles.items,
        { [styles.show]: currentDropDownState },
      )}>
        {availableSorting.map((item, index) => (
          <React.Fragment key={ item + index} >
            {(item.sorting !== defaultSort) && (
              <ClickElement
                tertiary
                ElementType="div"
                type="button"
                text={item.label}
                onClick={() => {
                  documentSetCookie(setCookieValue, item.sorting);
                  dispatch(changeSorting(item.sorting));
                  setDropDownState(false);
                }}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};